export enum UnlockRateOptionsType {
  ENABLE_ALL = 'ENABLE_ALL',
  DISABLE_ALL = 'DISABLE_ALL',
  DISABLE_RATE_OPTIONS = 'DISABLE_RATE_OPTIONS',
}
